import React from "react";
import { Input } from "../ui/input";

// Champ de spécification d'une catégorie : texte libre ou liste déroulante configurable
export function SpecFieldInput({ field, value, onChange, testId, placeholder }) {
    if (field.type === "select") {
        const options = field.options || [];
        const current = value || "";
        return (
            <select value={current} onChange={(e) => onChange(e.target.value)} className="w-full px-3 py-2 text-sm border rounded-md bg-white" data-testid={testId}>
                <option value="">— Non renseigné —</option>
                {current && !options.includes(current) && <option value={current}>{current}</option>}
                {options.map((o) => <option key={o} value={o}>{o}</option>)}
            </select>
        );
    }
    return <Input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={testId} />;
}
